module.exports = __webpack_public_path__ + "img/collection.8bc1a250.svg";